// Use the existing AI client from utils
import { getEdgeAIClient } from '../../api/utils';

async function run(prompt) {
    try {
        // Get the Edge AI client that's already configured
        const ai = getEdgeAIClient();
        
        const response = await ai.models.generateContent({
            model: 'gemini-2.5-pro',
            contents: prompt,
            config: {
                temperature: 1,
                topP: 0.95,
                topK: 64,
                maxOutputTokens: 8192,
            }
        });

        return response.text || "Sorry, I couldn't generate a response.";
    } catch (error) {
        console.error("Gemini API error:", error);
        return "Sorry, there was an error processing your request.";
    }
}

export default run;